import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-3 shadow-xl text-sm">
      <p className="font-semibold text-gray-700 dark:text-gray-300 mb-1">
        {label}
      </p>
      {payload.map((p, i) => (
        <p key={i} style={{ color: p.color }} className="font-medium">
          {p.name}:{" "}
          {p.name === "revenue"
            ? `$${p.value.toLocaleString()}`
            : p.value.toLocaleString()}
        </p>
      ))}
    </div>
  );
};

const RevenueAreaChart = ({ data }) => (
  <ResponsiveContainer width="100%" height={280}>
    <AreaChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
      <defs>
        <linearGradient id="revGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#6366f1" stopOpacity={0.3} />
          <stop offset="95%" stopColor="#6366f1" stopOpacity={0} />
        </linearGradient>
        <linearGradient id="usersGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#06b6d4" stopOpacity={0.3} />
          <stop offset="95%" stopColor="#06b6d4" stopOpacity={0} />
        </linearGradient>
      </defs>
      <CartesianGrid strokeDasharray="3 3" stroke="rgba(148,163,184,0.1)" />
      <XAxis
        dataKey="month"
        tick={{ fontSize: 12, fill: "#94a3b8" }}
        axisLine={false}
        tickLine={false}
      />
      <YAxis
        tick={{ fontSize: 12, fill: "#94a3b8" }}
        axisLine={false}
        tickLine={false}
        tickFormatter={(v) => `$${(v / 1000).toFixed(0)}k`}
      />
      <Tooltip content={<CustomTooltip />} />
      <Area
        type="monotone"
        dataKey="revenue"
        stroke="#6366f1"
        strokeWidth={2.5}
        fill="url(#revGrad)"
        dot={false}
        activeDot={{ r: 4, strokeWidth: 0, fill: "#6366f1" }}
      />
    </AreaChart>
  </ResponsiveContainer>
);

export default RevenueAreaChart;
